// Hook odpowiedzialny za pobranie url resolvera

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IHrefLang {
  language: string;
  url_shortcut: string;
}

// Nowy interfejs dla pojedynczego tłumaczenia SEO
// Backend zwraca tablicę takich obiektów: [{language: "pl", translation: "Tekst..."}]
export interface ISeoPageInfoTranslation {
  language: string;
  translation: string | null;
}

export interface IResponse {
  page_type: 'PRODUCTS' | 'PRODUCT' | 'CMS_PAGE' | 'HOME_PAGE' | 'ARTICLE_BLOG';
  parameters: string;
  href_lang: IHrefLang[];

  // Pola SEO z backendu - każdy to tablica tłumaczeń
  // Backend zwraca meta_title, meta_description, meta_keywords (zgodnie z DTO i bazą danych)
  meta_title?: ISeoPageInfoTranslation[];
  meta_description?: ISeoPageInfoTranslation[];
  meta_keywords?: ISeoPageInfoTranslation[];
  h1?: ISeoPageInfoTranslation[];
  open_graph_title?: ISeoPageInfoTranslation[];
  open_graph_description?: ISeoPageInfoTranslation[];
  open_graph_image?: string;
}

// parametry requestu do api
export type IRequest = {
  urlKey: string;
};

const getLayoutUrlResolver = (params?: IRequest): Promise<IResponse> =>
  axios.get('/layout/url_resolver', { params });

export const useGetLayoutUrlResolver = (
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['url-resolver', params],
    () => getLayoutUrlResolver(params),
    options
  );
